import { profileOption, readLinkOption, readWriteLinkOption, writeLinkOption } from '../constants';

function createReadTagSelected(link) {
    if ([readLinkOption, readWriteLinkOption].includes(link.type)) {
        return 2;
    }
    if ([profileOption].includes(link.type)) {
        return 1;
    }
    return 0;
}

function convertQuestionLinkViewToSave(link) {
    if (!link?.enabled) {
        return {};
    }
    return {
        ...link,
        enabled: 1,
        read_tag_selected: createReadTagSelected(link),
        read_tag: [readLinkOption, readWriteLinkOption].includes(link.type) ? link.read_tag : null,
        write_tag: [writeLinkOption, readWriteLinkOption].includes(link.type) ? link.write_tag : null,
        patient_table_id: link.patient_table?.id,
    };
}

export default convertQuestionLinkViewToSave;
